import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const RELAY_ITEM_API_URL = `${API_HOST}/api/relay/item`;

function* createRelayItem() {
  yield takeEvery(actions.CREATE_RELAY_ITEM, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], RELAY_ITEM_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_RELAY_ITEM_ENDED });
    }
  });
}

function* searchRelayItems() {
  yield takeEvery(actions.SEARCH_RELAY_ITEMS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${RELAY_ITEM_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_RELAY_ITEMS_ENDED });
    }
  });
}

function* updateRelayItem() {
  yield takeEvery(actions.UPDATE_RELAY_ITEM, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], RELAY_ITEM_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_RELAY_ITEM_ENDED });
    }
  });
}

function* deleteRelayItems() {
  yield takeEvery(actions.DELETE_RELAY_ITEMS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], RELAY_ITEM_API_URL, {
        data,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_RELAY_ITEMS_ENDED });
    }
  });
}

function* createRelayItemApi() {
  yield takeEvery(actions.CREATE_RELAY_ITEM_API, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${RELAY_ITEM_API_URL}/api`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_RELAY_ITEM_API_ENDED });
    }
  });
}

function* searchRelayItemApis() {
  yield takeEvery(actions.SEARCH_RELAY_ITEM_APIS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${RELAY_ITEM_API_URL}/api?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_RELAY_ITEM_APIS_ENDED });
    }
  });
}

function* findRelayItemApi() {
  yield takeEvery(actions.FIND_RELAY_ITEM_API, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${RELAY_ITEM_API_URL}/api/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_RELAY_ITEM_API_ENDED });
    }
  });
}

function* updateRelayItemApi() {
  yield takeEvery(actions.UPDATE_RELAY_ITEM_API, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${RELAY_ITEM_API_URL}/api`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_RELAY_ITEM_API_ENDED });
    }
  });
}

function* deleteRelayItemApis() {
  yield takeEvery(actions.DELETE_RELAY_ITEM_APIS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${RELAY_ITEM_API_URL}/api`, {
        data,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_RELAY_ITEM_APIS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createRelayItem),
    fork(searchRelayItems),
    fork(updateRelayItem),
    fork(deleteRelayItems),
    fork(createRelayItemApi),
    fork(searchRelayItemApis),
    fork(findRelayItemApi),
    fork(updateRelayItemApi),
    fork(deleteRelayItemApis),
  ]);
}
